var tourFeatureContainer = document.querySelector(".tour-features-container");
if (tourFeatureContainer) {
  vcTourFeatures(tourFeatureContainer);
}
